import * as CompanyContactInfo from './CompanyContactInfo.jsx';
import * as Logo from './Logo.jsx';
import Name from '../utility/Name.jsx';
import * as Separator from './Separator.jsx';
import * as Text from './Text.jsx';

const Blocks = {
    get: (group) => [
        {
            id: Name.Block.Company.Logo,
            component: Logo.Component,
            config: {
                Block: Logo.TypeConfig.panel.block(),
                Style: Logo.TypeConfig.panel.style()
            },
            display: 'Logo',
            group,
            image: 'logo.svg'
        },
        {
            id: Name.Block.Company.ContactMeta,
            component: CompanyContactInfo.Component,
            config: {
                Block: CompanyContactInfo.TypeConfig.panel.block(),
                Style: CompanyContactInfo.TypeConfig.panel.style()
            },
            display: 'Company Contact Info',
            group,
            image: 'address.svg'
        },
        ...Content.get(group)
    ]
};
const Content = {
    get: (group) => [
        {
            id: Name.Block.Text,
            component: Text.Component,
            config: {
                Block: Text.TypeConfig.panel.block(),
                Style: Text.TypeConfig.panel.style()
            },
            display: 'Text',
            group,
            image: 'text.png'
        },
        {
            id: Name.Block.Separator,
            component: Separator.Component,
            config: {
                Block: Separator.TypeConfig.panel.block(),
                Style: Separator.TypeConfig.panel.style()
            },
            display: 'Divider',
            group,
            image: 'hr.png'
        }
    ]
};
const Tokens = {
    get: (id) => {
        switch (id) {
            case Name.Block.Company.ContactMeta:
                return CompanyContactInfo.Tokens();
        }
    }
};

export {
    Blocks,
    Content,
    Tokens
}